export default class WebGLShaderPrecisionFormat {
  className = 'WebGLShaderPrecisionFormat';

  constructor({
    rangeMin, rangeMax, precision
  }) {
    this.rangeMin = rangeMin;
    this.rangeMax = rangeMax;
    this.precision = precision;
  }
}